export default __webpack_public_path__ + "Fascia_7_Dual.png";